import cookie from 'vue-cookie'

const state = {
  loginState: {
    data: {},
    success: false,
    errorMessage: ''
  },
  ticket: '',
  moduleRouteDictionary: {
    dataEdit: 'dataEditModule'
  },
  modules: [
    {
      name: '数据编辑',
      module: 'dataEditModule',
      path: '/dataEdit',
      route: 'dataEdit'
    }
  ],
  privilegeDictionary: {},
  queryPrivilege: false,

  // 以下为新系统
  // 注册弹框显示
  showRegister: false,

  // 登陆框显示
  showLogin: false,

  // 登录状态
  isLogin: !!cookie.get('cird-ticket'),
  comeFromOldSystem: cookie.get('comeFrom') === 'oldHomePage'
}

export default state



// WEBPACK FOOTER //
// ./src/vuex/state.js